import { useEffect } from "react";
import { stage, trackWithDefaultStage } from "@flights/et-universal";
import useGlobalContext from "hooks/useGlobalContext";
import { SUMMER_DEAL_COUNTRIES_LIST } from "../constants";

const useTrackSummerDeal = (isMobile: boolean) => {
  const { ipCountry = "" } = useGlobalContext();

  useEffect(() => {
    trackWithDefaultStage("flights_web_cat_summer_deal", 1);
    stage("flights_web_cat_summer_deal", isMobile ? 3 : 2);

    if (ipCountry === "us") {
      trackWithDefaultStage("flights_web_cat_summer_deal", 4);
    } else if (SUMMER_DEAL_COUNTRIES_LIST.includes(ipCountry)) {
      trackWithDefaultStage("flights_web_cat_summer_deal", 5);
    }
  }, [isMobile, ipCountry]);
};

export default useTrackSummerDeal;
